// 边缘光点束（border beam）：一段亮光沿容器边框缓慢旋转游走的高级感动效
// 实现：锥形渐变 + CSS @property 角度旋转（globals.css 的 --bb-angle），遮罩只留边框区域
// 兼容性：Chrome/Edge 85+、Safari 16.4+、Firefox 128+；不支持时边框静止为柔光描边，不破坏布局
// 用法：父容器加 relative + rounded-[x]，本组件作为最后一个子元素放入即可
import React from 'react'
import { cn } from '@/lib/utils'

export interface BorderBeamProps {
    className?: string
    /** 边框厚度（px） */
    borderWidth?: number
    /** 绕行一圈时长（秒） */
    duration?: number
    /** 光束颜色 */
    color?: string
}

export function BorderBeam({
    className,
    borderWidth = 2,
    duration = 5,
    color = '#bfdbfe',
}: BorderBeamProps) {
    return (
        <div
            aria-hidden
            className={cn('pointer-events-none absolute inset-0 rounded-[inherit]', className)}
            style={{
                padding: borderWidth,
                background: `conic-gradient(from var(--bb-angle), transparent 0%, transparent 55%, ${color} 70%, #ffffff 78%, ${color} 86%, transparent 100%)`,
                WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                WebkitMaskComposite: 'xor',
                maskComposite: 'exclude',
                animation: `bb-rotate ${duration}s linear infinite`,
            }}
        />
    )
}
